import React from "react"
import { useTranslation } from "react-i18next"

import { FloorFormModel } from "features/floor-management/types/FloorFormModel"
import { FloorFormTabType } from "features/floor-management/types/FloorFormTabType"
import { FloorOverlay } from "widgets/floor/floor-overlay/FloorOverlay"

export interface EditFloorOverlayModel {
  floorFormModel: FloorFormModel
  isLoading?: boolean
  isSubmitting?: boolean
  defaultTab?: FloorFormTabType
  onCancel?: () => void
}

export interface EditFloorOverlayProps extends EditFloorOverlayModel {
  autoFocus?: boolean
}

export const EditFloorOverlay = React.memo((props: EditFloorOverlayProps) => {
  const { t } = useTranslation()
  return (
    <FloorOverlay
      id="edit-floor-overlay"
      formID="edit-floor-overlay-form"
      className="edit-floor-overlay"
      headline={t("Floor.Actions.Update")}
      prefix="floor__edit"
      submitButtonText={t("Floor.Actions.Update")}
      {...props}
    />
  )
})

EditFloorOverlay.displayName = "EditFloorOverlay"
